import deps from "../depsloader";

export default () => {
  const elms = document.querySelectorAll(".lightgallery");
  const galleryImage = document.querySelector(".expose-swiper");
  if (!elms || !galleryImage) {
    return;
  }

  deps.load("lightgallery").then(() => {
    for (let element of elms) {
      let config = null;
      if (element.dataset.config) {
        config = element.dataset.config;
        element.removeAttribute("data-config");
      }

      lightGallery(element, JSON.parse(config)); // eslint-disable-line
    }

    if (galleryImage) {
      lightGallery(galleryImage, { // eslint-disable-line
        selector: '.swiper-slide > a.gallery-link'
      });
    }

    const exposeBtn = document.querySelector(".expose-gallery-btn");
    if (exposeBtn) {
      exposeBtn.addEventListener("click", function(e) {
        e.preventDefault();

        const activeSlide = document.querySelector(".expose-swiper .swiper-slide-active > a.gallery-link");
        activeSlide.click();
      });
    }
  });
}
